/**
 * The thinnest possible localStorage wrapper — SPEC.md §12 (M0).
 *
 * No schema, no draft, no history: those arrive in M6. This exists in M0 only
 * so that M2's persisted splitter has a legal place to write, and so CLAUDE.md
 * rule 9 (wrap every localStorage call in try/catch) holds from the first write
 * rather than being retrofitted.
 *
 * Safari in private mode throws on access, and a full quota throws on write.
 * Neither is worth an error card: storage is a convenience, so every failure
 * here degrades to "we didn't persist it" and the app carries on.
 */

/** Reads a key. Returns null when missing, or when storage is unavailable. */
export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

/** Writes a key. Returns whether it actually persisted. */
export function writeStorage(key: string, value: string): boolean {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

/** Removes a key. Returns whether it actually happened. */
export function removeStorage(key: string): boolean {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}
